module.exports = __webpack_public_path__ + "static/media/reviewComp.8dce7e6e.png";